export enum ScheduleWeekDaySwedish {
  Monday = 'Måndag',
  Tuesday = 'Tisdag',
  Wednesday = 'Onsdag',
  Thursday = 'Torsdag',
  Friday = 'Fredag',
  Saturday = 'Lördag',
  Sunday = 'Söndag',
  OutOfRange = 'outOfRange',
}
